var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, File } from '@1amageek/ballcap';
import { Base } from '.';
export class Message extends Base {
    static collectionReference() {
        return super.collectionReference().doc('v1').collection('messages');
    }
    imageStoragePath(myRoom) {
        return `${myRoom.documentReference.path}/messages/${this.id}/images`;
    }
    toResetUnreadData(newIsUnread) {
        return [
            'isUnread',
            newIsUnread,
            'images',
            this.images,
            'roomId',
            this.roomId,
            'userId',
            this.userId,
            'text',
            this.text,
        ];
    }
    setImageFromCloudStorage(data) {
        const image = new File();
        console.log('snapshot.downloadURL', data);
        image.path = data.path;
        image.url = data.url;
        image.metadata = {
            name: data.metadata.name,
        };
        this.images = [image];
    }
}
Message.imagesMaxSize = 1;
__decorate([
    Field,
    __metadata("design:type", String)
], Message.prototype, "roomId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Message.prototype, "userId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Message.prototype, "text", void 0);
__decorate([
    Field,
    __metadata("design:type", Array)
], Message.prototype, "images", void 0);
__decorate([
    Field,
    __metadata("design:type", Boolean)
], Message.prototype, "isUnread", void 0);
